import {
    FILE_UPLOAD_UPDATE,
} from '../constants';

const DEFAULT_STATE = {
  counter: [],
    finnishedFields: [],
    active: false,
};

export const fileUpload = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
      case FILE_UPLOAD_UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
